import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "px-4" }
const _hoisted_2 = { class: "mt-6 lg:w-1/2 xl:w-1/3" }
const _hoisted_3 = { class: "mt-6 lg:w-1/2 xl:w-1/3" }
const _hoisted_4 = { class: "mt-6 lg:w-1/2 xl:w-1/3" }
const _hoisted_5 = { class: "mt-6 lg:w-1/2 xl:w-1/3" }
const _hoisted_6 = { class: "mt-6 lg:w-1/2 xl:w-1/3" }
const _hoisted_7 = { class: "mt-6 lg:w-1/2 xl:w-1/3" }
const _hoisted_8 = { class: "mt-6 lg:w-1/2 xl:w-1/3" }
const _hoisted_9 = { class: "mt-6 lg:w-1/2 xl:w-1/3" }
const _hoisted_10 = { class: "mt-6 lg:w-1/2 xl:w-1/3" }
const _hoisted_11 = { class: "mt-6 lg:w-1/2 xl:w-1/3" }

import { // store
		localesStore
	} from '@/store/locales'

	import { // vue
		ref 
	} from 'vue'

	
	const __default__ = { name: 'SoundDetails' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		meeting: {
			type: Object,
			default: () => {return {}}
		},
		loading: {
			type: Boolean,
			default: false
		}
	},
  setup(__props) {

	const props = __props

	const store = localesStore()

	const tabs = ref([
		{ name: store.getLabel('533'), current: true }, // Genres
		{ name: store.getLabel('517'), current: false },  // Decades
		{ name: store.getLabel('504'), current: false }, // Tag
		{ name: store.getLabel('367'), current: false },  // Common Uses
		{ name: store.getLabel('403'), current: false },  // Artists
		{ name: store.getLabel('184'), current: false },  // Albums
		{ name: store.getLabel('182'), current: false },  // Songs
		{ name: store.getLabel('219'), current: false },  // Borrowed Items
		{ name: store.getLabel('165'), current: false },  // BGMs
		{ name: store.getLabel('205'), current: false },  // Notes
	])

	const childTabs = ref<{_tabs: []}>({_tabs: []})

return (_ctx: any,_cache: any) => {
  const _component_tw_tabs_underline = _resolveComponent("tw-tabs-underline")!
  const _component_tw_table_column = _resolveComponent("tw-table-column")!
  const _component_tw_table = _resolveComponent("tw-table")!
  const _component_CheckIconMini = _resolveComponent("CheckIconMini")!
  const _component_MinusIconMini = _resolveComponent("MinusIconMini")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_tw_tabs_underline, {
      ref_key: "childTabs",
      ref: childTabs,
      tabs: tabs.value
    }, null, 8, ["tabs"]),
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_tw_table, null, {
          default: _withCtx(() => [
            _createVNode(_component_tw_table_column, {
              header: _unref(store).getLabel('330')
            }, {
              default: _withCtx(({row}) => [
                _createTextVNode(_toDisplayString(row["fc_calendar_sample_event__attendee__ROLES__roleID::name_display"]), 1)
              ]),
              _: 1
            }, 8, ["header"])
          ]),
          _: 1
        })
      ])
    ], 512), [
      [_vShow, childTabs.value?._tabs?.[0]?.current]
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_tw_table, null, {
          default: _withCtx(() => [
            _createVNode(_component_tw_table_column, {
              header: _unref(store).getLabel('518')
            }, {
              default: _withCtx(({row}) => [
                _createTextVNode(_toDisplayString(row["fc_calendar_sample_event__attendee__ROLES__roleID::name_display"]), 1)
              ]),
              _: 1
            }, 8, ["header"])
          ]),
          _: 1
        })
      ])
    ], 512), [
      [_vShow, childTabs.value?._tabs?.[1]?.current]
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_tw_table, null, {
          default: _withCtx(() => [
            _createVNode(_component_tw_table_column, {
              header: _unref(store).getLabel('503')
            }, {
              default: _withCtx(({row}) => [
                _createTextVNode(_toDisplayString(row["fc_calendar_sample_event__attendee__ROLES__roleID::name_display"]), 1)
              ]),
              _: 1
            }, 8, ["header"])
          ]),
          _: 1
        })
      ])
    ], 512), [
      [_vShow, childTabs.value?._tabs?.[2]?.current]
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_tw_table, null, {
          default: _withCtx(() => [
            _createVNode(_component_tw_table_column, {
              header: _unref(store).getLabel('1')
            }, {
              default: _withCtx(({row}) => [
                _createTextVNode(_toDisplayString(row["fc_calendar_sample_event__attendee__ROLES__roleID::name_display"]), 1)
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_tw_table_column, {
              header: _unref(store).getLabel('280')
            }, {
              default: _withCtx(({row}) => [
                _createTextVNode(_toDisplayString(row["fc_calendar_sample_event__attendee__ROLES__roleID::name_display"]), 1)
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_tw_table_column, {
              header: _unref(store).getLabel('190')
            }, {
              default: _withCtx(({row}) => [
                _createTextVNode(_toDisplayString(row["fc_calendar_sample_event__attendee__ROLES__roleID::name_display"]), 1)
              ]),
              _: 1
            }, 8, ["header"])
          ]),
          _: 1
        })
      ])
    ], 512), [
      [_vShow, childTabs.value?._tabs?.[3]?.current]
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_tw_table, null, {
          default: _withCtx(() => [
            _createVNode(_component_tw_table_column, {
              header: _unref(store).getLabel('282')
            }, {
              default: _withCtx(({row}) => [
                _createTextVNode(_toDisplayString(row["fc_calendar_sample_event__attendee__ROLES__roleID::name_display"]), 1)
              ]),
              _: 1
            }, 8, ["header"])
          ]),
          _: 1
        })
      ])
    ], 512), [
      [_vShow, childTabs.value?._tabs?.[4]?.current]
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_tw_table, null, {
          default: _withCtx(() => [
            _createVNode(_component_tw_table_column, {
              header: _unref(store).getLabel('281')
            }, {
              default: _withCtx(({row}) => [
                _createTextVNode(_toDisplayString(row["fc_calendar_sample_event__attendee__ROLES__roleID::name_display"]), 1)
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_tw_table_column, {
              header: _unref(store).getLabel('282')
            }, {
              default: _withCtx(({row}) => [
                _createTextVNode(_toDisplayString(row["fc_calendar_sample_event__attendee__ROLES__roleID::name_display"]), 1)
              ]),
              _: 1
            }, 8, ["header"])
          ]),
          _: 1
        })
      ])
    ], 512), [
      [_vShow, childTabs.value?._tabs?.[5]?.current]
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_tw_table, null, {
          default: _withCtx(() => [
            _createVNode(_component_tw_table_column, {
              header: _unref(store).getLabel('177')
            }, {
              default: _withCtx(({row}) => [
                _createTextVNode(_toDisplayString(row["fc_calendar_sample_event__attendee__ROLES__roleID::name_display"]), 1)
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_tw_table_column, {
              header: _unref(store).getLabel('282')
            }, {
              default: _withCtx(({row}) => [
                _createTextVNode(_toDisplayString(row["fc_calendar_sample_event__attendee__ROLES__roleID::name_display"]), 1)
              ]),
              _: 1
            }, 8, ["header"])
          ]),
          _: 1
        })
      ])
    ], 512), [
      [_vShow, childTabs.value?._tabs?.[6]?.current]
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_tw_table, null, {
          default: _withCtx(() => [
            _createVNode(_component_tw_table_column, {
              header: _unref(store).getLabel('625')
            }, {
              default: _withCtx(({row}) => [
                _createTextVNode(_toDisplayString(row["fc_calendar_sample_event__attendee__ROLES__roleID::name_display"]), 1)
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_tw_table_column, {
              header: _unref(store).getLabel('157') + '?'
            }, {
              default: _withCtx(({row}) => [
                (row['fc_calendar_sample_event__ATTENDEES__calendarID::meeting_with'])
                  ? (_openBlock(), _createBlock(_component_CheckIconMini, {
                      key: 0,
                      class: "h-5 w-5 text-black"
                    }))
                  : (_openBlock(), _createBlock(_component_MinusIconMini, {
                      key: 1,
                      class: "h-5 w-5 text-gray-300"
                    }))
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_tw_table_column, {
              header: _unref(store).getLabel('158') + '?'
            }, {
              default: _withCtx(({row}) => [
                (row['fc_calendar_sample_event__ATTENDEES__calendarID::meeting_with'])
                  ? (_openBlock(), _createBlock(_component_CheckIconMini, {
                      key: 0,
                      class: "h-5 w-5 text-black"
                    }))
                  : (_openBlock(), _createBlock(_component_MinusIconMini, {
                      key: 1,
                      class: "h-5 w-5 text-gray-300"
                    }))
              ]),
              _: 1
            }, 8, ["header"])
          ]),
          _: 1
        })
      ])
    ], 512), [
      [_vShow, childTabs.value?._tabs?.[7]?.current]
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_tw_table, null, {
          default: _withCtx(() => [
            _createVNode(_component_tw_table_column, {
              header: _unref(store).getLabel('158')
            }, {
              default: _withCtx(({row}) => [
                _createTextVNode(_toDisplayString(row["fc_calendar_sample_event__attendee__ROLES__roleID::name_display"]), 1)
              ]),
              _: 1
            }, 8, ["header"])
          ]),
          _: 1
        })
      ])
    ], 512), [
      [_vShow, childTabs.value?._tabs?.[8]?.current]
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_tw_table, null, {
          default: _withCtx(() => [
            _createVNode(_component_tw_table_column, {
              header: _unref(store).getLabel('205')
            }, {
              default: _withCtx(({row}) => [
                _createTextVNode(_toDisplayString(row["fc_calendar_sample_event__attendee__ROLES__roleID::name_display"]), 1)
              ]),
              _: 1
            }, 8, ["header"])
          ]),
          _: 1
        })
      ])
    ], 512), [
      [_vShow, childTabs.value?._tabs?.[9]?.current]
    ])
  ]))
}
}

})